import React from "react";
import "./ag_grid_overlay.less";

export interface AgGridOverlayComponentProps {
  text: string;
  customStyle?: React.CSSProperties;
}

const AgGridOverlay: React.FC<AgGridOverlayComponentProps> = ({
  text,
  customStyle,
}) => {
  return (
    <div className="ag-grid-overlay" style={customStyle}>
      {text}
    </div>
  );
};

export default AgGridOverlay;
